import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { baseApiService } from "../../../services/api/axios-config/axios-config";
import { SelectField } from "../../ui";

export interface SectorOption {
  id: string;
  name: string;
  origin?: string;
}

interface InputSetoresProps {
  name: string;
  label: string;
  methods: any;
  helperText?: string;
  disabled?: boolean;
}

export default function InputSetores({
  name,
  label,
  methods,
  helperText,
  disabled = false,
}: InputSetoresProps) {
  const { control, formState } = methods;
  const { errors } = formState;
  const [setores, setSetores] = useState<SectorOption[]>([]);

  useEffect(() => {
    const fetchSetores = async () => {
      const response = await baseApiService.get("sector-category/select");
      setSetores(response.data.data || []);
    };
    fetchSetores();
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <SelectField
          label={label}
          error={!!errors[name]}
          helperText={errors[name]?.message?.toString() || helperText}
          disabled={disabled}
          value={field.value || ""}
          onChange={(event) => field.onChange(event.target.value)}
        >
          <option value="">Selecione...</option>
          {setores.map((sector) => (
            <option key={sector.id} value={sector.id}>
              {sector.name}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}

